<template>
  <settings-modal
    :locked="isLoading"
    class="t-cashback-remove-modal"
  >
    <span
      slot="heading"
      class="font-weight-bold"
    >Remove cashback rate</span>

    <div class="mb-4">
      <v-layout row>
        <v-flex xs2>
          <v-subheader class="v-subheader--dense">From:</v-subheader>
        </v-flex>
        <v-flex xs10>
          <div class="subheading t-from-value">{{ modal.data.rate.amountFrom }}</div>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs2>
          <v-subheader class="v-subheader--dense theme--light">Rate:</v-subheader>
        </v-flex>
        <v-flex xs10>
          <div class="subheading t-rate-value">{{ modal.data.rate.percent }}%</div>
        </v-flex>
      </v-layout>
    </div>

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-confirm-button"
        color="error"
        medium
        flat
        :disabled="isLoading"
        @click="onDeleteButtonClick"
      >remove rate</v-btn>

      <v-btn
        class="t-cancel-button"
        color="primary"
        medium
        flat
        :disabled="isLoading"
        @click="onCloseButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import SettingsModal from '@/components/modals/SettingsModal.vue'
  import modal from '@/mixins/modal'
  import flashMessages from '@/mixins/flashMessages'
  import { mapActions, mapGetters } from 'vuex'
  import ErrorAlert from '@/components/ui/ErrorAlert.vue'
  import form from '@/mixins/form'

  export default {
    name: 'CashbackRemoveModal',
    components: {
      ErrorAlert,
      SettingsModal
    },
    mixins: [form, modal, flashMessages],
    data () {
      return {
        error: null,
        isLoading: false
      }
    },
    computed: {
      ...mapGetters('modal', ['modal'])
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onDeleteButtonClick () {
        this.modal.data.removeCallback((execute) => {
          this.setError(null)
          this.setIsLoading(true)

          execute(this.modal.data.rate)
            .then(() => this.closeModal())
            .catch((error) => this.setError(error))
            .finally(() => this.setIsLoading(false))
        })
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      setIsLoading (isLoading) {
        this.$set(this, 'isLoading', isLoading)
      }
    }
  }
</script>
